module.exports = __webpack_public_path__ + "visionexam-desktop___U7Sxj.svg";